/* PAROS — interactions for the px-* sections. No dependencies. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isRTL = () => document.documentElement.dir === 'rtl';
  const define = (name, cls) => { if (!customElements.get(name)) customElements.define(name, cls); };
  const wake = (root) => root && root.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });

  /* ---------- horizontal rail: arrows + gold progress line ---------- */
  class PxRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.px-rail__track');
      if (!this.track) return;
      this.bar = this.querySelector('.px-rail__bar');
      this.prev = this.querySelector('[data-px-prev]');
      this.next = this.querySelector('[data-px-next]');
      this.prev?.addEventListener('click', () => this.go(-1));
      this.next?.addEventListener('click', () => this.go(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.ro = new ResizeObserver(() => this.update());
      this.ro.observe(this.track);
      this.update();
    }
    disconnectedCallback() { this.ro?.disconnect(); }
    go(dir) {
      const step = Math.max(this.track.clientWidth * 0.85, 200) * dir * (isRTL() ? -1 : 1);
      this.track.scrollBy({ left: step, behavior: reduce ? 'auto' : 'smooth' });
    }
    update() {
      const t = this.track;
      const max = t.scrollWidth - t.clientWidth;
      const pos = Math.abs(t.scrollLeft);
      const ratio = max > 0 ? pos / max : 0;
      if (this.bar) {
        const w = max > 0 ? Math.max(t.clientWidth / t.scrollWidth, 0.1) : 1;
        this.bar.style.width = (w * 100) + '%';
        this.bar.style.transform = `translateX(${(isRTL() ? -1 : 1) * ratio * (1 / w - 1) * 100}%)`;
      }
      if (this.prev) this.prev.disabled = pos <= 2;
      if (this.next) this.next.disabled = pos >= max - 2;
    }
  }
  define('px-rail', PxRail);

  /* ---------- showroom: rotate products inside the arch ---------- */
  class PxShowroom extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.px-show__slide')];
      this.cards = [...this.querySelectorAll('.px-placard__item')];
      this.thumbs = [...this.querySelectorAll('.px-show__thumb')];
      this.dur = (parseFloat(this.dataset.autoplay) || 0) * 1000;
      this.i = 0;
      if (this.slides.length < 2) return;
      this.thumbs.forEach((b, n) => b.addEventListener('click', () => { this.show(n); this.hold = true; this.stop(); }));
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => { if (!this.hold) this.play(); });
      this.addEventListener('focusin', () => this.stop());
      document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : (!this.hold && this.play())));
      this.play();
    }
    disconnectedCallback() { this.stop(); }
    play() { this.stop(); if (this.dur && !reduce) this.t = setInterval(() => this.show(this.i + 1), this.dur); }
    stop() { clearInterval(this.t); }
    show(n) {
      const len = this.slides.length;
      this.i = (n + len) % len;
      this.slides.forEach((s, k) => s.classList.toggle('is-active', k === this.i));
      this.cards.forEach((c, k) => c.classList.toggle('is-active', k === this.i));
      this.thumbs.forEach((b, k) => b.setAttribute('aria-pressed', k === this.i));
      wake(this.slides[this.i]);
    }
  }
  define('px-showroom', PxShowroom);

  /* ---------- atelier: choose a house ---------- */
  class PxAtelier extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((t, n) => {
        t.addEventListener('click', () => this.select(n));
        t.addEventListener('keydown', (e) => {
          const fwd = ['ArrowDown', isRTL() ? 'ArrowLeft' : 'ArrowRight'];
          const back = ['ArrowUp', isRTL() ? 'ArrowRight' : 'ArrowLeft'];
          let d = fwd.includes(e.key) ? 1 : back.includes(e.key) ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          const m = (n + d + this.tabs.length) % this.tabs.length;
          this.select(m); this.tabs[m].focus();
        });
      });
      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:block:select', (e) => {
          const n = this.tabs.findIndex((t) => t.dataset.blockId === e.detail.blockId);
          if (n > -1) this.select(n);
        });
      }
    }
    select(n) {
      this.tabs.forEach((t, k) => {
        const on = k === n;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        const p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) { p.hidden = !on; if (on) { wake(p); p.querySelector('px-rail')?.update?.(); } }
      });
      this.tabs[n].scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
    }
  }
  define('px-atelier', PxAtelier);
  class PxSeries extends PxAtelier {}
  define('px-series', PxSeries);
})();
